/**
 * Text-Only-Button (kein Rahmen, nur Schrift).
 * Wie auf Login z. B. „Passwort vergessen?“: color=theme.color.accent (oder weglassen = Theme-Default).
 */
import { useTheme } from "@/theme/ThemeProvider";
import { Pressable, Text, ViewStyle } from "react-native";

type Props = {
  onPress: () => void;
  children: string;
  color?: string;
  style?: ViewStyle;
};

export function TextButton({ onPress, children, color, style }: Props) {
  const { theme } = useTheme();

  return (
    <Pressable onPress={onPress} style={[{ alignItems: "center" }, style]}>
      <Text
        style={{
          color: color ?? theme.color.accent,
          fontSize: theme.fontSize.small,
          fontWeight: "800",
        }}
      >
        {children}
      </Text>
    </Pressable>
  );
}
